import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedPslfDashboardForgivenessEstimatorIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  model() {
    // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
    return this.store.adapterFor('user').getLoanSummary(this.sessionContext.user.id);
  }
}
